module.exports = __webpack_public_path__ + "static/media/bg_price_plan_under_30.4bf0ceec.webp";